import axios from "axios";
import { getToken } from "../api/jwt";
import * as log from "../lib/log";
// import {LOGIN_URL} from '../constants/links'
import { Alerts } from "../ui";

// const SESSION_REDIRECT_TO = process.env.SESSION_REDIRECT_TO || LOGIN_URL;
const showConsole = true;

// BASEURL
const baseURLAPI =
  process &&
  process.env &&
  process.env.NODE_ENV &&
  process.env.NODE_ENV === "development" &&
  process.env.SERVER_URL
    ? process.env.SERVER_URL
    : "";

// CONFIG
const timeout = 20000; // Было 10 сек, поменял на 20, так как создание отчёта за день, требует много времени.
const withCredentials = true;

export const API = axios.create({
  baseURL: baseURLAPI,
  timeout,
  withCredentials
  /* other custom settings */
});

async function getHeadersAuth() {
  try {
    let token = await getToken();

    return { headers: { Authorization: token } };
  } catch (err) {
    log.error("getHeadersAuth", err);

    return {};
  }
}

export async function get(url, requestParams) {
  try {
    return axiosThen(
      await API.get(url, { ...(await getHeadersAuth()) }),
      requestParams
    );
  } catch (err) {
    return axiosCatch(err, requestParams);
  }
}

export async function post(url, data, requestParams) {
  try {
    return axiosThen(
      await API.post(url, data, { ...(await getHeadersAuth()) }),
      requestParams
    );
  } catch (err) {
    return axiosCatch(err, requestParams);
  }
}

export async function login(url, data, requestParams) {
  try {
    return axiosThen(
      await API.post(url, data, { ...(await getHeadersAuth()) }),
      requestParams
    );
  } catch (err) {
    return axiosCatch(err, { ...(requestParams || {}), isLoginAxios: true });
  }
}

export async function put(url, data, requestParams) {
  try {
    return axiosThen(
      await API.put(url, data, { ...(await getHeadersAuth()) }),
      requestParams
    );
  } catch (err) {
    return axiosCatch(err, requestParams);
  }
}

export async function patch(url, data, requestParams) {
  try {
    return axiosThen(
      await API.patch(url, data, { ...(await getHeadersAuth()) }),
      requestParams
    );
  } catch (err) {
    return axiosCatch(err, requestParams);
  }
}

export async function _delete(url, requestParams) {
  try {
    return axiosThen(
      await API.delete(url, { ...(await getHeadersAuth()) }),
      requestParams
    );
  } catch (err) {
    return axiosCatch(err, requestParams);
  }
}

export function axiosThen(response, requestParams = {}) {
  const showAlert = !requestParams || !requestParams.noMessage;

  if (showConsole) {
    if (
      process &&
      process.env &&
      process.env.NODE_ENV &&
      process.env.NODE_ENV === "development"
    ) {
      console.log("axiosThen", response);
    }
  }

  const result = {
    success: (response && response.data && response.data.success) || false,
    message: (response && response.data && response.data.message) || null,
    count: (response && response.data && response.data.count) || 0,
    data:
      (response && response.data && (response.data.data || response.data)) ||
      {},
    meta: (response && response.data && response.data.meta) || {}
  };

  if (showAlert) {
    if (result.message) {
      if (typeof result.message === "string") {
        Alerts.success(result.message);
      } else if (Array.isArray(result.message)) {
        Alerts.success(result.message.join(", "));
      } else if (typeof result.message === "object") {
        let messageString = "";

        for (let messageKey in result.message) {
          messageString += `${messageKey}: ${result.message[messageKey]}. `;
        }

        Alerts.success(messageString);
      } else {
        console.log("Result message (success): ", result.message);
      }
    }
  }

  if (requestParams && requestParams.isLoginAxios) {
    return result;
  } else {
    return result.success && result.data
      ? requestParams && requestParams.full
        ? result
        : requestParams && requestParams.returnIsError
        ? false
        : result.data
      : null;
  }
}

export function axiosCatch(err, requestParams = {}) {
  const showAlert = !requestParams || !requestParams.noMessage;

  if (showConsole) {
    if (
      process &&
      process.env &&
      process.env.NODE_ENV &&
      process.env.NODE_ENV === "development"
    ) {
      console.log("axiosCatch", err);
    }
  }

  const code = (err && err.response && err.response.status) || 0;

  // Не авторизован
  if (code === 401) {
    if (typeof window !== "undefined") {
      if ((requestParams && requestParams.isLoginAxios) || requestParams.full) {
        const result = {
          success: false,
          message:
            (err &&
              err.response &&
              err.response.data &&
              err.response.data.message) ||
            err.message,
          data: {},
          err
        };

        if (requestParams.full) {
          return result;
        } else {
          return requestParams && requestParams.returnIsError ? true : result;
        }
      } else {
        console.log("ERROR: ", err);
        // logout();

        // window.location = '/'
        // return;
      }
    }
  } else {
    const result = {
      success: false,
      message:
        (err &&
          err.response &&
          err.response.data &&
          err.response.data.message) ||
        err.message,
      data: (err && err.response && err.response.data) || {},
      err
    };

    if (showConsole) {
      console.log("ERROR: ", err);
    }

    if (showAlert) {
      if (result.message) {
        if (typeof result.message === "string") {
          Alerts.error(result.message);
        } else if (Array.isArray(result.message) && result.message.length) {
          Alerts.error(result.message.join(", "));
        } else if (
          typeof result.message === "object" &&
          Object.keys(result.message).length
        ) {
          let messageString = "";

          for (let messageKey in result.message) {
            messageString += `${messageKey}: ${result.message[messageKey]}. `;
          }

          Alerts.error(messageString);
        } else {
          console.log("Result message (success): ", result.message);
        }
      }
    }

    if (requestParams && requestParams.full) {
      return result;
    } else {
      return requestParams && requestParams.returnIsError ? true : null;
    }
  }
}
